<template>
  <div class="ui-timer">
    <div class="time">
      <input :disabled="inCount" class="input" type="tel" v-model="min" min="0">
      <span class="unit">分</span>
    </div>
    <div class="time">
      <input :disabled="inCount" class="input" type="tel" v-model="sec" min="0" maxlemgth="2">
      <span class="unit">秒</span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'UiTimer',
  data() {
    return {
      timer: null,
      inCount: false,
      timerStartedAt: null,
    }
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    localStorageKey: {
      type: String,
      default: 'hoge',
    },
  },
  computed: {
    min: {
      get() {
        return Math.floor(this.value / 60)
      },
      set(min) {
        this.$emit('input', ~~min * 60 + this.sec)
      },
    },
    sec: {
      get() {
        return this.value % 60
      },
      set(sec) {
        this.$emit('input', this.min * 60 + ~~sec)
      },
    },
  },
}
</script>

<style scoped lang="scss">
.ui-timer {
  display: flex;
  overflow: hidden;
  border: 1px solid $light;
  border-radius: $round;
}

.time {
  position: relative;
  flex: 1;

  + .time {
    border-left: 1px solid $light;
  }
}

.input {
  font: inherit;
  box-sizing: border-box;
  width: 100%;
  padding: 9px;
  vertical-align: middle;
  border: 0;
  outline: 0;
  box-shadow: 0;

  &:focus {
    background: $focus;
  }
}

.unit {
  font-size: 10px;
  line-height: 1;
  position: absolute;
  top: calc(50% - 0.5em);
  right: 1em;
  pointer-events: none;
}
</style>
